export class Cpf {
  private static CPF_BLACKLIST = [
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999',
  ];

  private static CPF_REGEX = /^[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}$/;
  private static CPF_ONLY_NUMBERS_REGEX = /^[0-9]{3}[0-9]{3}[0-9]{3}[0-9]{2}$/;

  public static isValid(cpf: string, checkOnlyNumber: boolean = false): boolean {
    // Remove caracteres não numéricos
    const cleanedCPF = cpf.replace(/[^\d]+/g, '');

    // Verifica se o CPF tem 11 dígitos ou se é uma sequência repetida (ex: 111.111.111-11)
    if (cleanedCPF.length !== 11 || /^(\d)\1{10}$/.test(cleanedCPF)) {
      return false;
    }

    const cpfArray = cleanedCPF.split('').map(Number);

    // Valida o primeiro dígito verificador
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += cpfArray[i] * (10 - i);
    }

    let firstCheckDigit = 11 - (sum % 11);
    if (firstCheckDigit >= 10) {
      firstCheckDigit = 0;
    }
    if (cpfArray[9] !== firstCheckDigit) {
      return false;
    }

    // Valida o segundo dígito verificador
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += cpfArray[i] * (11 - i);
    }

    let secondCheckDigit = 11 - (sum % 11);
    if (secondCheckDigit >= 10) {
      secondCheckDigit = 0;
    }
    return cpfArray[10] === secondCheckDigit;
  }

  public static format(value: string | number): string {
    const cpf = String(value).replace(/\D/g, '');
    if (cpf.length !== 11) {
      return String(value);
    }
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
}
